import { render } from "./TermsPrivacyPage.vue?vue&type=template&id=5a24b64b&scoped=true"
import script from "./TermsPrivacyPage.vue?vue&type=script&lang=js"
export * from "./TermsPrivacyPage.vue?vue&type=script&lang=js"

import "./TermsPrivacyPage.vue?vue&type=style&index=0&id=5a24b64b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a24b64b"]])

export default __exports__